import styled from 'styled-components';
import colors from '~styles/colors';

export const TableRow = styled.tr`
  border-bottom: 1px solid ${`${colors.grayRegular}40`};
  td {
    padding: 12px 5px;
  }
`;
